import { SignUpForm } from "@/components/auth/auth-forms";

export function SignUpPage({
  onAuth,
}: {
  onAuth: () => void | Promise<void>;
}) {
  return <SignUpForm onAuth={onAuth} />;
}
